// src/version.js
// Única fuente de verdad de la versión del módulo BAC Sarampión. La usan:
//   - public/service-worker.js (el número se copia ahí automáticamente
//     al hacer build — ver scripts/syncVersion.js)
//   - el footer (BacSarampionHome.jsx, BacLogin.jsx)
//
// Súbela en cada despliegue — con eso alcanza, no hay que tocar 2 archivos.
export const APP_VERSION = "1.0.32";
